/**
 * KAN-849: route ends of a client-facing channel card ("Клиент -> Бот").
 *
 * `direction` in the channel catalog only splits client-facing channels
 * ('incoming') from event delivery ('outgoing'). Inside the client-facing group
 * some channels are started by the bot (cold outreach from bought Telegram
 * accounts), so the card shows "Бот -> Клиент" for them. This is the single
 * place that lists such channels; every other client-facing channel keeps
 * "Клиент -> Бот".
 */
export type ChannelRouteEnds = readonly [from: string, to: string];

const CLIENT_TO_BOT: ChannelRouteEnds = ['Клиент', 'Бот'];
const BOT_TO_CLIENT: ChannelRouteEnds = ['Бот', 'Клиент'];

/** Client-facing channels where the bot writes first. */
const BOT_INITIATED_CHANNELS: ReadonlySet<string> = new Set(['telegram_user']);

/** Route ends ("from", "to") for a client-facing channel card. */
export function clientRouteEnds(codename: string): ChannelRouteEnds {
  return BOT_INITIATED_CHANNELS.has(codename) ? BOT_TO_CLIENT : CLIENT_TO_BOT;
}
